import * as React from "react";
import { forwardRef } from "react";
const SvgDownArrowRed = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", focusable: "false", xmlns: "http://www.w3.org/2000/svg", color: "#FF3366", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 6v9.586l-3.793-3.793a.999.999 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A.993.993 0 0 0 12 19a.993.993 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0z", fill: "currentColor", fillRule: "evenodd" }));
const ForwardRef = forwardRef(SvgDownArrowRed);
export default ForwardRef;
